import { AuditTct } from '@dealstack/shared/lib/generated';

export const PERSON_TABLE_NAME = 'Person';

export const getLatestBasicDetailsAudit = (audits: AuditTct[] | undefined): AuditTct | null =>
	audits?.find((audit) => audit.tableName === PERSON_TABLE_NAME) ?? null;
